import React, { useEffect, useState } from 'react';
import { ReactSession } from 'react-client-session';
import axios from 'axios';
import Header from '../components/header';
import Sidebar from '../components/sidebar';
import Footer from '../components/footer';
import { Paginator } from 'primereact/paginator';

function App() {

	const apiKey = 'erpTrucoo';
    const [employeeData, setEmployeeData] = useState('');
	const [first, setFirst] = useState(0); 
    const [rows, setRows] = useState(5); 

    const getEmployee = async () => {
		try {
			const response = await axios.post('https://api.trucoo.in/employees/all-employee/', employeeData, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
			console.log(response.data);
			if(response.data.status === 'success'){
				setEmployeeData(response.data.data);
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
	};

	const onPageChange = (event) => {
		setFirst(event.first);
	};

	useEffect(() => {
		getEmployee();
	},[]);

return(
<>
    <Header />
    <Sidebar />

    <div class="content-wrapper">
		<div class="container-full">
		
			<section class="content">
			<div class="box">
				<div class="box-header with-border">
				  <h4 class="box-title">Employee Data</h4>
				  <p class="mb-0 box-subtitle">All Employee Data</p>
				</div>
				<div class="box-body">
					<div class="table-responsive">
					  <table id="example" class="table text-fade table-bordered table-hover display nowrap margin-top-10 w-p100">
						<thead>
							<tr class="text-dark">
								<th>ID</th>
								<th>Name</th>
								<th>Position</th>
								<th>Email</th>
								<th>Phone</th>
								<th>Start date</th>
								<th>View</th>
								
							</tr>
						</thead>
						<tbody>
							{employeeData.length > 0 ? employeeData.slice(first, first + rows).map((employee, index) =>
							<tr key={index}>
								<td>{employee.employeeId}</td>
								<td class="text-dark">{employee.employeeName}</td>
								<td>{employee.position}</td>
								<td>{employee.companyEmail}</td>
								<td>{employee.employeePhone}</td>
								<td>{employee.joinedDate}</td>
								<td>
									<a href={`/employee-report?id=${employee.id}`} class="form-control" style={{textAlign: 'center'}}>View</a>
								</td>
								
							</tr>
							):(
								<tr>
									<td colSpan={6}>No Employee Data</td>
								</tr>
							)}
							
						</tbody>	
					</table>
					<Paginator className="custom-paginator" first={first} rows={rows} totalRecords={employeeData?.length}  onPageChange={onPageChange} />
					</div>              
				</div>
			  </div>
			</section>
		</div>
	</div>

	<Footer />
</>
);
}

export default App;